import type { IAppState } from 'services/app-state-provider';
import { isValidThreadSummary, type ThreadSummary } from 'services/connectivity/agent-chat-api/types/summary';
import { ChatsEntitiesActions } from 'store/entities/chats/actions';
import { getThread } from 'store/entities/chats/selectors';
import { ArchivesViewActions } from 'store/views/archives/actions';

interface ThreadSummarySetPayload {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  chat_id: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  thread_id: string;
  summary: ThreadSummary;
}

export function handleThreadSummarySet(payload: ThreadSummarySetPayload, store: IAppState): void {
  const { thread_id: threadId, summary } = payload;

  if (!isValidThreadSummary(summary)) {
    return;
  }

  const state = store.getState();
  const thread = getThread(state, threadId);

  if (thread) {
    store.dispatch(
      ChatsEntitiesActions.updateChatThread({
        threadId,
        thread: { summary },
      }),
    );
  } else {
    store.dispatch(
      ArchivesViewActions.updateArchiveThreadSummary({
        threadId,
        summary,
      }),
    );
  }
}
